// extracted by mini-css-extract-plugin
export var footer = "_pn-5";
export var fulfillmentInput = "_pn-0";
export var shipDateInput = "_pn-1";
export var shipmentModal = "_pn-2";
export var shipmentModalContent = "_pn-3";
export var tableContainer = "_pn-4";